const IconTrophy = ({ color }) => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.25 23.917H8.75" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path
        d="M15 21.583C15 22.1353 14.5523 22.583 14 22.583C13.4477 22.583 13 22.1353 13 21.583H15ZM13 21.583V18.6663H15V21.583H13Z"
        fill={color}
      />
      <path d="M12.25 11.083H15.75" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path
        d="M6.41634 16.9163C6.41634 16.9163 4.08301 15.1663 4.08301 12.2497C4.08301 11.3568 4.08301 10.5732 4.08301 9.9157C4.08301 9.60652 4.08301 9.45192 4.10012 9.32196C4.21827 8.42449 4.92449 7.71827 5.82196 7.60012C5.95192 7.58301 6.10673 7.58301 6.41634 7.58301V7.58301C6.72595 7.58301 6.88076 7.58301 7.01073 7.60012C7.90819 7.71827 8.61441 8.42449 8.73256 9.32196C8.74967 9.45192 8.74967 9.60673 8.74967 9.91634V11.083"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M21.5837 16.9163C21.5837 16.9163 23.917 15.1663 23.917 12.2497C23.917 11.3568 23.917 10.5732 23.917 9.9157C23.917 9.60652 23.917 9.45192 23.8999 9.32196C23.7817 8.42449 23.0755 7.71827 22.178 7.60012C22.0481 7.58301 21.8933 7.58301 21.5837 7.58301V7.58301C21.274 7.58301 21.1192 7.58301 20.9893 7.60012C20.0918 7.71827 19.3856 8.42449 19.2674 9.32196C19.2503 9.45192 19.2503 9.60673 19.2503 9.91634V11.083"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M19.25 13.6096V8.41699C19.25 7.31242 18.3546 6.41699 17.25 6.41699H10.75C9.64543 6.41699 8.75 7.31242 8.75 8.41699V13.6096C8.75 14.947 9.41841 16.1959 10.5312 16.9378L13.4453 18.8805C13.7812 19.1045 14.2188 19.1045 14.5547 18.8805L17.4688 16.9378C18.5816 16.1959 19.25 14.947 19.25 13.6096Z"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  )
}

export default IconTrophy
